import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { displaySteps, isPropositionInLock } from '../../utils/dataUtils';
import MgpFormRadio from '../../elements/MgpFormRadio/MgpFormRadio';
import { IAdditionalData, IBeneficiaryAdditionReq, IInfoStep, relationType } from '../../context/model';
import { accessJsonAttr, getAge } from '../../utils/utils';
import { useState } from 'react';
import { ZoomableImageModal } from '../../modals/common/ImageWithZoomModal';

type InfoBeneficiaryStep0FormData = {
  hasPartner: string;
  hasChild: string;
}

export default function InfoBeneficiaryStep0FormComponent() {

  const {
    state: { proposition, updatedProposition, socialSecurityDocuments, additionalData, showModal, infoSteps, familyDoc },
    dispatch,
  } = useAppState();

  const validationSchema = Yup.object().shape({
    hasPartner: Yup.string().required(ERROR_MESSAGES.requiredMsg),
    hasChild: Yup.string().required(ERROR_MESSAGES.requiredMsg),
  });

  const [isShowSubText, setIsShowSubText] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<InfoBeneficiaryStep0FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      hasChild: additionalData?.hasChild !== undefined ? additionalData?.hasChild.toString() : undefined,
      hasPartner: additionalData?.hasPartner !== undefined ? additionalData?.hasPartner.toString() : undefined,
    },
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = (data: InfoBeneficiaryStep0FormData) => {
    let tempUpdatedPropo = updatedProposition;
    let tempAdditionalData = additionalData ?? {} as IAdditionalData;
    const hasAddedBeneficiary = proposition?.configuration.canBeAddedBeneficiaries && (data.hasPartner === 'true' || data.hasChild === 'true');
    let beneficiaries = [] as IBeneficiaryAdditionReq[];
    let isChild = '';

    if (hasAddedBeneficiary) {
      beneficiaries =  updatedProposition?.beneficiaries ? updatedProposition?.beneficiaries : [];
      socialSecurityDocuments?.filter(el => el.extractedData).map(doc => doc.extractedData?.beneficiaries?.map((extractedInfo) => {
        if (proposition.contact.nir !== extractedInfo.nir && beneficiaries.findIndex(el => el.contact.nir === extractedInfo.nir) === -1) {
          if (getAge(extractedInfo.birthDate) < 18) {
            isChild = relationType.CHILD;
          }
          const beneficiaryProps = {
            relationType: isChild,
            isConfirmed: false,
            contact: {
              firstName: extractedInfo.firstName,
              lastName: extractedInfo.lastName,
              birthDate: extractedInfo.birthDate,
              civilityCode: extractedInfo.civilityCode,
              regimeCode: extractedInfo.regimeCode,
              attachmentOrganization: extractedInfo.socialSecurityOrg,
              nir: extractedInfo.nir,
              nirKey: extractedInfo.nirKey,
              rank: extractedInfo.rank
            }
          } as IBeneficiaryAdditionReq;
          
          beneficiaries.push(beneficiaryProps)
        }
      })); 
  };

    if(tempUpdatedPropo) {
      tempAdditionalData.hasPartner = data.hasPartner === 'true';
      tempAdditionalData.hasChild = data.hasChild === 'true';
      tempUpdatedPropo.beneficiaries = beneficiaries;
    };

    let steps = [...infoSteps] as IInfoStep[];
    const indexOfStep1 = steps.findIndex(el => el.path === APP_URLS.infoBeneficiaryStep1Page);

    if (data.hasChild === 'false' && data.hasPartner === 'false') {
      if (indexOfStep1 !== -1) {
        const index1 = steps.findIndex(step => step.path === APP_URLS.infoBeneficiaryStep1Page);
        steps.splice(index1, 1);
        const index2 = steps.findIndex(step => step.path === APP_URLS.infoBeneficiaryStep2Page);
        steps.splice(index2, 1);
        const index3 = steps.findIndex(step => step.path === APP_URLS.familyDocumentsPage);
        steps.splice(index3, 1);

        dispatch({type: "UPDATE_STEPS", steps: steps})
      }
      if (familyDoc?.length > 0) {
        dispatch({type: 'UPLOAD_FAMILY_DOCUMENT', familyDoc: []});
      }
      
      let nextUrl = APP_URLS.recapPage;
      if(proposition?.configuration.hasOfferStep){
        nextUrl = APP_URLS.guarantyPage;
      }
      dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo, additionalData: tempAdditionalData});
      navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
      });
    } else {
      if (indexOfStep1 === -1) {
        dispatch({type: "UPDATE_STEPS", steps: displaySteps(proposition!)})
      }
        dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoBeneficiaryStep1Page, updatedProposition: tempUpdatedPropo, additionalData: tempAdditionalData});
        navigate({
          pathname: APP_URLS.infoBeneficiaryStep1Page,
          search: `?id=${proposition!.propositionId}`,
        });
    }
  }

  const onPreviousAction = () => {
      dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoPersoRecapPage});
      navigate({
        pathname: APP_URLS.infoPersoRecapPage,
        search: `?id=${proposition!.propositionId}`,
      });
  }

  const onShowSubText = (e:any) => {
    e.preventDefault();
    setIsShowSubText(!isShowSubText);
  }

  const onShowModal = (e:any) => {
    e.preventDefault();
    setIsShowModal(true);
  }

  return (         
      <form style={{width: '100%'}}>  
        <div className='form-row page-content'>
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <h2 className='card-title bleu'>Possibilité d’affilier mes ayants droit</h2>
            <p className='text mt-md fw-medium mb-sm'>Votre employeur vous offre la possibilité d’inscrire des ayants droit sur votre contrat&nbsp;:</p>
            <ul className='list-bullet-noir'>
              <li>Conjoint</li>
              <li>Enfants de moins de 20 ans et, sous conditions, de plus de 21 ans</li>
            </ul>
            <button className='button-bloc buttons-bloc ml-sm' onClick={(e) => onShowSubText(e)}>
              <p className='bleu link' >Vérifier les conditions d’éligibilité</p>
              <i className={`${isShowSubText ? "icon-chevron-top" : "icon-chevron-bottom"} bleu fz-xs ml-xs`}></i>
            </button>
            
            {isShowSubText &&
              <div className='text mt-xs p-sm fz-sm sub-text ml-sm'>
                Un enfant de 21 à 25 ans peut être couvert s'il justifie de la poursuite de ses études, est en contrat d'apprentissage ou est demandeur d'emploi.
                <br/>
                Les enfants handicapés peuvent être couverts sans limite d'âge.
              </div>
            }
            <p className='text mt-md mb-sm fw-medium'>Ils bénéficient de la même garantie que vous.</p>
            <p className='text'>Pour chaque ayant droit ajouté au contrat, vous réglez une cotisation additionnelle, intégralement à votre charge.</p>
            <p className='text bleu'>Une gratuité est appliquée sur les enfants de moins de 20 ans dès le 3<sup>e</sup> enfant.</p>

            <div>
              <p className='text fw-medium mt-md'>Vous souhaitez renforcer votre couverture avec l’Option 1 ou l’Option 2&nbsp;:</p>
              <br/>
              <ul className='list-bullet-noir'>
              <li>L’option choisie s’applique à l’ensemble des bénéficiaires inscrits sur le contrat socle obligatoire, </li>
              <li>Pour chaque bénéficiaire de l'option choisie, vous réglez une cotisation additionnelle.</li>
            </ul>
            </div>
            <button className='cta-bleu cta-small' onClick={(e) => onShowModal(e)}>Consulter les tarifs applicables aux ayants droit et aux options ici</button>
          </div>

          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <div className='pb-xl'>
              <h2 className='card-title bleu'>Souhaitez vous ajouter des ayants droit ? <span className='fushia'> (*)</span></h2>
              <div className='form-row mt-lg'>
                <h2 className='form-group mw-40 card-title bleu pt-xs'>
                  Votre conjoint 
                </h2>
                <div className='flex va-center ta-center'>
                  <MgpFormRadio id="hasPartner" value='true' label='Oui' register={register} errors={errors}/>
                  <MgpFormRadio id="hasPartner" value='false' label='Non' register={register} errors={errors}/>
                </div>
              </div>
              {errors && accessJsonAttr(errors, 'hasPartner') && <p className="error fushia m-y-xs">Veuillez choisir au moins une case</p>}
              
              <div className='pb-xl'>
                <div className='form-row'>
                  <h2 className='form-group mw-40 card-title bleu pt-xs'>Vos enfants</h2>
                  <div className='flex va-center ta-center'>
                    <MgpFormRadio id="hasChild" value='true' label='Oui' register={register} errors={errors}/>
                    <MgpFormRadio id="hasChild" value='false' label='Non' register={register} errors={errors}/>
                  </div> 
                </div> 
                <div className='form-row pb-xl'>
                  {errors && accessJsonAttr(errors, 'hasChild') && <p className="error fushia m-y-xs">Veuillez choisir au moins une case</p>} 
                </div>
              </div>
            </div>
              <div className="pt-xl">
                <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
              </div>
          </div>    
        </div>      
      

        {
          !showModal && <StickButtonsBloc disabledPreviousButton={proposition && isPropositionInLock(proposition) ? true : false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>
        }

        {
          isShowModal && <ZoomableImageModal onClose={() => setIsShowModal(false)} isOpen={true} src={process.env.REACT_APP_RESSOURCE_BASE_URL + `/img/Tarif-mesuelle-2026.png`} />
        }

      </form>
  )
}
